import React, { useRef } from 'react'
import { useEffect, useState } from 'react'
import './home_dos.css'
import Dot from '../../../assets/imgs/home_dos/dots.png'
import IdeasEnCorto from '../../../assets/imgs/home_dos/IdeasEnCorto.png'
import { useAxios } from '../../../hooks/useAxios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import Modal2 from "../../../components/modal/Modal";
import ModalVideo from "../../../components/modal/ModalVideo";

const Home_dos = () => {

	const [t, i18n] = useTranslation("home");
	const [g] = useTranslation("global");
	const liga_lang1 = '/' + i18n.language + "/Ideas-en-Corto";

	const { data, isloading } = useAxios(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/ideas/gnideas?offset=0&next=6&lang=${i18n.language}`);
	const liga_lang = '/' + i18n.language + "/Ideas-en-Corto";

	const [ideas, setIdeas] = useState(null);
	const [hasImageHover, setHasImageHover] = useState(false);
	const imageSelected = useRef("");

	const navigate = useNavigate();
	const isMobile = useRef(false);

	const [isModalOpen2, setIsModalOpen2] = useState(false);
	const [id_liga, setId_liga] = useState("");
	const [variable1, setVariable1] = useState("");
	const [variable2, setVariable2] = useState("");

	const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
	const [urlVideo, setUrlVideo] = useState("");

	const openModal2 = (value1, value2, value3, value4) => {
		setVariable1(value1);
		setVariable2(value2);
		setId_liga(value4);
		setIsModalOpen2(true);
		{/*navigator.clipboard
			.writeText(
				`${window.location.origin}/${i18n.language}/Ideas-en-Corto${value3}`
			)
			.then(() => {
				console.log("copied");
			});*/}
	};

	const closeModal2 = () => {
		setVariable1("");
		setVariable2("");
		setIsModalOpen2(false);
	};

	const openModalVideo = (contenido) => {
		setUrlVideo(contenido);
		setIsOpenModalVideo(true);
	};

	const closeModalVideo = () => {
		setUrlVideo("");
		setIsOpenModalVideo(false);
	};

	useEffect(() => {
		const width = window?.innerWidth;
		if (width <= 820) {
			isMobile.current = true;
		} else {
			isMobile.current = false;
		}
	}, []);



	const renderizarMensaje = (tipo, contenido, preview, id) => {
		
		if (tipo === "texto") {
			return;
		} else if (tipo === "imagen") {
			openModal2(contenido, "", preview, id);
			return;
		} else if (tipo === "texto-video") {
			openModal2(contenido, "", preview, id)
			return;
		} else if (tipo === "texto-imagen") {
			openModal2(contenido, "", preview, id)
			return;
		} else if (tipo === "carrete") {
			openModal2(contenido, "carrete", preview, id);
			return;
		} else if (tipo === "youtube") {
			openModalVideo(contenido);
			return;
		} else if (tipo === "video") {
			openModal2("https://www.ricardosalinas.com" + contenido, "video", preview, id);
			return;
		} else {
			return;
		}
	};

	const handleClickOutside = (circleId) => {
		if (!imageSelected.current || !isMobile.current) return;
		if (circleId === imageSelected.current) {
			setHasImageHover(false);
			imageSelected.current = "";
		}
	};

	const ref1 = useOutsideClick(() => { handleClickOutside("circulo_1") });
	const ref2 = useOutsideClick(() => { handleClickOutside("circulo_2") });
	const ref3 = useOutsideClick(() => { handleClickOutside("circulo_3") });
	const ref4 = useOutsideClick(() => { handleClickOutside("circulo_4") });
	const ref5 = useOutsideClick(() => { handleClickOutside("circulo_5") });
	const ref6 = useOutsideClick(() => { handleClickOutside("circulo_6") });

	const onClickCircle = (imgId, tipo, contenido, preview, id) => {
		

		if (!isMobile.current) {
			//navigate(liga_lang1);
			renderizarMensaje(tipo, contenido, preview, id);
		}
		imageSelected.current = imgId;
		if (!hasImageHover) {
			setHasImageHover(true);
			return;
		}
		//navigate(liga_lang1);
		renderizarMensaje(tipo, contenido, preview, id);
		imageSelected.current = "";
		setHasImageHover(false);
	}

	useEffect(() => {
		if (data) {
			setIdeas(data);
		}
	}, [data])

	if (isloading || ideas === null) {
		return (
			<div className="home_dos">Is Loading...</div>
		)
	}

	return (
		<div className='cont_home_dos'>
			<div className="home_dos">
				<div className="dot_1">
					<img src={Dot} alt='Imagen de cuadro con puntos' />
				</div>
				<div className="circulo_1 circulo_img">
					<div
						onClick={() => {
							onClickCircle("circulo_1",ideas[0].tipo,ideas[0].contenido,ideas[0].preview,ideas[0].id )
						}}>
						<img
							src={'https://www.ricardosalinas.com' + ideas[0].preview}
							className="circulo_1img"
							id='animatedElement1'
							ref={ref1}
							alt='Imgaen home RBS'
						/>
					</div>
				</div>
				<div className="circulo_2 circulo_img">
					<div onClick={() => {
						onClickCircle("circulo_2",ideas[1].tipo,ideas[1].contenido,ideas[1].preview,ideas[1].id )
					}}>
						<img
							src={'https://www.ricardosalinas.com' + ideas[1].preview}
							className="circulo_2img"
							id='animatedElement2'
							ref={ref2}
							alt='Imgaen home RBS'
						/>
					</div>
				</div>
				<div className="circulo_3 circulo_img">
					<div onClick={() => {
						onClickCircle("circulo_3",ideas[2].tipo,ideas[2].contenido,ideas[2].preview,ideas[2].id )
					}}>
						<img
							src={'https://www.ricardosalinas.com' + ideas[2].preview}
							className="circulo_3img"
							id='animatedElement3'
							ref={ref3}
							alt='Imgaen home RBS'
						/>
					</div>
				</div>
				<div className="ideas_en_corto">
					<img src={(t('ideas.img'))} className="ideas_img" alt='Imagen Ideas' />
					<p>
						<div className='div_dos_no_bold' dangerouslySetInnerHTML={{ __html: (t('ideas.quote')) }}></div>
					</p>
					{/* Boton para resolucion mayor a celulares */}
					<a href={liga_lang} className="bt_explorar">{(g('general.explorer'))}</a>
				</div>
				<div className="circulo_4 circulo_img">
					<div onClick={() => {
						onClickCircle("circulo_4",ideas[3].tipo,ideas[3].contenido,ideas[3].preview,ideas[3].id )
					}}>
						<img
							src={'https://www.ricardosalinas.com' + ideas[3].preview}
							className="circulo_4img"
							id='animatedElement1'
							ref={ref4}
							alt='Imagen home RGBs'
						/>
					</div>
				</div>
				<div className="dot_3">
					<img src={Dot} alt='Imagen de cuadro con puntos' />
				</div>
				<div className="circulo_5 circulo_img">
					<div onClick={() => {
						onClickCircle("circulo_5",ideas[4].tipo,ideas[4].contenido,ideas[4].preview,ideas[4].id )
					}}>
						<img
							src={'https://www.ricardosalinas.com' + ideas[4].preview}
							className="circulo_5img"
							id='animatedElement2'
							ref={ref5}
							alt='Imagen Hime RBS'
						/>
					</div>
				</div>
				<div className="dot_2">
					<img src={Dot} alt='Imagen de cuadro con puntos' />
				</div>
				<div className="circulo_6 circulo_img">
					<div onClick={() => {
						onClickCircle("circulo_6",ideas[5].tipo,ideas[5].contenido,ideas[5].preview,ideas[5].id )
					}}>
						<img
							src={'https://www.ricardosalinas.com' + ideas[5].preview}
							className="circulo_6img"
							id='animatedElement3'
							ref={ref6}
							alt='Imagen Hime RBS'
						/>
					</div>
				</div>
				<div className="ideas_en_corto_movil_img">
					<img src={(t('ideas.img'))} className="ideas_img" alt='Imagen ideas' />
				</div>
				<div className="ideas_en_corto_movil_p">

					<p className='pad'>
						<div className='div_dos_no_bold' dangerouslySetInnerHTML={{ __html: (t('ideas.quote-mobile')) }}></div>
					</p>

					{/* Boton para resolucion para celulares */}
					<a href={liga_lang} className="bt_explorar">{(g('general.explorer'))}</a>
				</div>
			</div>
			<Modal2
				isOpen={isModalOpen2}
				closeModal={closeModal2}
				id_idea={id_liga}
				variable1={variable1}
				variable2={variable2}
			/>

			<ModalVideo
				isOpen={isOpenModalVideo}
				closeModal={closeModalVideo}
				urlVideo={urlVideo}
			/>
		</div>
	)
}

export default Home_dos
